import React, { Component } from "react";
import { Button, Modal, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import FloatingButton from "../../Material/FloatingButton";
import { connect } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import ReactTooltip from "react-tooltip";
import * as moment from "moment";
import Moment from "react-moment";
import XLSX from "xlsx";
import * as FileSaver from "file-saver";
import { apiFetch } from "../../../apiFetch";

toast.configure();
class delegationlist extends Component {
  constructor(props) {
    super(props);

    this.state = {
      listArray: [],
      delegatedlistitem: [],
      StaffDetailslistArray: [],
      deletePopup: false,
      deleteId: "",
      loading: "",
      deletemode: "",
      deleteappid: "",
      deleteappname: "",
      deletedelid: "",
      deletedelname: "",
      deletereferno: "",
      updatemode: "",
      updateappid: "",
      updateappname: "",
      updatedelid: "",
      updatedelname: "",
      updatereferno: "",
      updateunidelegationid: "",
      deleteunidelegationid: "",
      delagationpopup: false,
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      popupdelegationSection: "",
      downloadExcel: [],
      downloadExcelArray: [],
      isdownloadExcelFirstLoadDone: 0,
    };
  }

  componentDidMount() {
    this.props.dispatch({ type: "headerTitle", value: "Delegation" });
    this.GetListData();
  }

  GetListData = (val) => {
    // alert('a')
    let postData = { DelegationId: "0" };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/GetDelegatedApprovers",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          this.setState({
            delegatedlistitem: data.DelegatedApproverList,
            loading: "Yes",
          });
          // console.log("have to check"+JSON.stringify(this.state.accesslistitem))
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  handlechange = (e) => {
    switch (e.target.name) {
      case "popupdelegationEmployeeId":
        this.setState({ popupdelegationEmployeeId: e.target.value });
        break;
      case "popupdelegationEmployeeName":
        this.setState({ popupdelegationEmployeeName: e.target.value });
        break;

      default:
        break;
    }
  };

  searchdelegationEmployee = () => {
    // alert('a')
    this.setState({ stafflistArraySpin: "", StaffDetailslistArray: [] });
    let postData = {
      EmployeeId: this.state.popupdelegationEmployeeId,
      Name: this.state.popupdelegationEmployeeName,
      Section: this.state.popupdelegationSection,
    };
    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL + "/api/GGP/GetStaffDetails",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        //console.log(data)
        if (data) {
          this.setState({
            StaffDetailslistArray: data.StaffDetails,
            stafflistArraySpin: "none",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  handledelegationSelectFormFields = (selectedOption) => {
    this.setState({ popupdelegationSection: selectedOption.value });
  };

  searchdelegationEmployeeClear = () => {
    this.setState({
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
      popupdelegationSection: "",
      StaffDetailslistArray: [],
      stafflistArraySpin: "none",
    });
  };

  _handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchdelegationEmployee();
    }
  };

  deleteRecord = (value) => {
    this.setState({
      deletePopup: true,
      deletemode: value.TypeofMode,
      deleteappid: value.Originalapproverid,
      deleteappname: value.Originalapprovername,
      deletedelid: value.Delegatetoempid,
      deletedelname: value.Delegatetoname,
      deletereferno: value.Referenceno,
      deleteunidelegationid: value.DelegationId,
    });
  };

  cancelDelete = () => {
    this.setState({ deletePopup: false, deleteId: "" });
  };

  getdelegationhide = () => {
    this.setState({
      delagationpopup: false,
      popupdelegationEmployeeId: "",
      popupdelegationEmployeeName: "",
    });
  };

  getdelegationDetails = (id, name) => {
    if (this.state.updateappid === id) {
      toast.error("Approver and Delegated person can't be same", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } else {
      if (this.state.updatedelid === id) {
        toast.error("You are selecting the same person again", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
      } else {
        this.setState({
          popupdelegationEmployeeId: "",
          popupdelegationEmployeeName: "",
          popupdelegationSection: "",
          StaffDetailslistArray: [],
          delagationpopup: false,
        });

        let postData = {
          TypeofMode: this.state.updatemode,
          Originalapproverid: this.state.updateappid,
          Originalapprovername: this.state.updateappname,
          Delegatetoempid: id,
          Delegatetoname: name,
          Createdby: this.props.UserId,
          Createdbyname: this.props.userName,
          Referenceno: this.state.updatereferno,
          Mode: "Update",
          DelegationId: this.state.updateunidelegationid,
        };

        apiFetch(
          process.env.REACT_APP_WEB_SERVICE_URL +
            "/api/AccessPrivilege/InsertUpdateDelegatedApprovers",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.props.getToken,
            },
            body: JSON.stringify(postData),
          }
        )
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 401) {
              this.props.dispatch({ type: "Token", value: "" });
              this.props.dispatch({ type: "profile", value: "" });
              this.props.dispatch({ type: "userType", value: "" });
            }
          })
          .then((data) => {
            // console.log(JSON.stringify(postData));
            if (data) {
              if (data.Status === "Success") {
                this.GetListData();
                this.setState({
                  updatemode: "",
                  updateappid: "",
                  updateappname: "",
                  updatedelid: "",
                  updatedelname: "",
                  updatereferno: "",
                  updateunidelegationid: "",
                });
                toast.success("Updated successfully.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              } else {
                this.setState({
                  updatemode: "",
                  updateappid: "",
                  updateappname: "",
                  updatedelid: "",
                  updatedelname: "",
                  updatereferno: "",
                  updateunidelegationid: "",
                });
                toast.error(data.Message, {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
            this.props.history.push({ pathname: "/somethingwrong" });
          });
      }
    }
  };

  confirmDelete = () => {
    this.setState({ deletePopup: false });
    let postData = {
      TypeofMode: this.state.deletemode,
      Originalapproverid: this.state.deleteappid,
      Originalapprovername: this.state.deleteappname,
      Delegatetoempid: this.state.deletedelid,
      Delegatetoname: this.state.deletedelname,
      Createdby: this.props.UserId,
      Createdbyname: this.props.userName,
      Referenceno: this.state.deletereferno,
      Mode: "Delete",
      DelegationId: this.state.deleteunidelegationid,
    };

    apiFetch(
      process.env.REACT_APP_WEB_SERVICE_URL +
        "/api/AccessPrivilege/InsertUpdateDelegatedApprovers",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.props.getToken,
        },
        body: JSON.stringify(postData),
      }
    )
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
        }
      })
      .then((data) => {
        if (data) {
          if (data.Status === "Success") {
            this.GetListData();
            this.setState({
              deletemode: "",
              deleteappid: "",
              deleteappname: "",
              deletedelid: "",
              deletedelname: "",
              deletereferno: "",
              deleteunidelegationid: "",
            });
            toast.success("Deleted successfully.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          } else {
            this.setState({
              deletemode: "",
              deleteappid: "",
              deleteappname: "",
              deletedelid: "",
              deletedelname: "",
              deletereferno: "",
              deleteunidelegationid: "",
            });
            toast.error(data.Message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.history.push({ pathname: "/somethingwrong" });
      });
  };

  // editGoods = (id) =>{
  //   var CryptoJS = require("crypto-js");
  //   window.location = process.env.REACT_APP_ENV +"/typeofgoods/edit?p=" + id;
  // }

  edit = (value) => {
    this.setState({
      updatemode: value.TypeofMode,
      updateappid: value.Originalapproverid,
      updateappname: value.Originalapprovername,
      updatedelid: value.Delegatetoempid,
      updatedelname: value.Delegatetoname,
      updatereferno: value.Referenceno,
      updateunidelegationid: value.DelegationId,
    });

    if (value.TypeofMode === "GGP-ReferenceNo") {
      var CryptoJS = require("crypto-js");
      window.location =
        process.env.REACT_APP_ENV +
        "/Delegation/create?p=" +
        encodeURI(
          CryptoJS.AES.encrypt(
            JSON.stringify(value.Referenceno),
            process.env.REACT_APP_ENCRYPT_PASSWORD
          ).toString()
        );
      // this.setState({
      //   delagationpopup: true,
      //   popupdelegationEmployeeId: "",
      //   popupdelegationEmployeeName: "",
      //   stafflistArraySpin: "none",
      // });
    } else {
      var CryptoJS = require("crypto-js");
      window.location =
        process.env.REACT_APP_ENV +
        "/Delegation/edit?p=" +
        encodeURI(
          CryptoJS.AES.encrypt(
            JSON.stringify(value.DelegationId),
            process.env.REACT_APP_ENCRYPT_PASSWORD
          ).toString()
        );
    }
  };

  downloadExcelFile = () => {
    const Heading = [
      {
        header1: "S.No",
        header2: "Referenceno",
        header3: "Type of Mode",
        header4: "Original Approver ",
        header5: "Delegated By",
        header6: "Delegated To",
        header7: "From Date",
        header8: "To Date",
      },
    ];
    (async () => {
      await this.setState({ downloadExcelArray: [] });
    })();
    if (this.state.downloadExcel.length > 0) {
      (async () => {
        await this.state.downloadExcel.forEach((value, index) => {
      

          let mdData = [
            value.data[0],
            value.data[1],
            value.data[2],
            value.data[3],
            value.data[4],
            value.data[5],
            value.data[6],
            value.data[7],
          ];
          this.state.downloadExcelArray.push(mdData);
     
          return null;
        });
      })();
    } else {
      (async () => {
        await this.state.delegatedlistitem.forEach((value, index) => {
  
          let mdData = [
            value.DelegationId,
            value.Referenceno,
            value.TypeofMode,
            value.Originalapproverid
              ? value.Originalapproverid + " - " + value.Originalapprovername
              : "Null",
            value.Createdby
              ? `${value.Createdby} - ${value.Createdbyname} (${moment(
                  value.CreatedDatetime
                ).format("DD-MM-yyyy HH:mm")}) `
              : "--",
            value.Delegatetoempid
              ? value.Delegatetoempid + " - " + value.Delegatetoname
              : "Null",
            value.Fromdate ? moment(value.Fromdate).format("DD-MM-yyyy") : "",
            value.Todate ? moment(value.Todate).format("DD-MM-yyyy") : "",
          ];
          // let mdData = [
          //   value.DelegationId,
          //   value.TypeofMode,
          //   value.Originalapproverid
          //     ? value.Originalapproverid + " - " + value.Originalapprovername
          //     : "Null",
          //   value.Delegatetoempid
          //     ? value.Delegatetoempid + " - " + value.Delegatetoname
          //     : "Null",
          //   value.Referenceno,
          //   value.Fromdate
          //     ? moment(value.Fromdate).format("DD-MM-yyyy HH:mm:ss")
          //     : "",
          //   value.Todate
          //     ? moment(value.Todate).format("DD-MM-yyyy HH:mm:ss")
          //     : "",
          // ];

          this.state.downloadExcelArray.push(mdData);
          return null;
        });
      })();
    }

    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const filename = "Delegation.xlsx";

    const ws = XLSX.utils.json_to_sheet(Heading, {
      skipHeader: true,
      origin: 0,
    });
    XLSX.utils.sheet_add_json(ws, this.state.downloadExcelArray, {
      skipHeader: true,
      origin: -1,
    });
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, filename);
  };

  render() {
    let sectionOptionList = [];
    if (this.state.SectionlistArray) {
      this.state.SectionlistArray.map((data) => {
        let sData = { id: "popupSection", label: data.Code, value: data.Code };
        sectionOptionList.push(sData);
        return null;
      });
    }

    let dataArray = [];
    this.state.delegatedlistitem.map((data) => {
      if (data?.Referenceno) {
        let mdData = [
          data.DelegationId,
          data.Referenceno,
          data.TypeofMode,
          data.Originalapproverid
            ? data.Originalapproverid + " - " + data.Originalapprovername
            : "Null",
          data.Createdby
            ? `${data.Createdby} - ${data.Createdbyname} (${moment(
                data.CreatedDatetime
              ).format("DD-MM-yyyy HH:mm")}) `
            : "--",
          data.Delegatetoempid
            ? data.Delegatetoempid + " - " + data.Delegatetoname
            : "Null",
          data.Fromdate ? moment(data.Fromdate).format("DD-MM-yyyy") : "",
          data.Todate ? moment(data.Todate).format("DD-MM-yyyy") : "",
          data,
        ];
        dataArray.push(mdData);
        return null;
      }
    });

    const columns = [
      {
        name: "DelegationId",
        label: "S.No",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Referenceno",
        label: "Referenceno",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "TypeofMode",
        label: "Type of Mode",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Originalapproverid",
        label: "Original Approver",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Createdby",
        label: "Delegated By",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Delegatetoempid",
        label: "Delegated To",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "Fromdate",
        label: "From Date",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Todate",
        label: "To Date",
        options: {
          filter: true,
          sort: true,
        },
      },

      {
        name: "action",
        label: "Action",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <>
                <ReactTooltip />
                <img
                  className="action-right-space mouse-pointer"
                  style={{ width: "25px" }}
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/edit-solid.svg"
                  }
                  data-tip="Edit"
                  onClick={() => this.edit(value)}
                />

                <img
                  className="action-right-space mouse-pointer"
                  src={
                    process.env.REACT_APP_ENV +
                    "/assets/images/icons/action/ionic-md-close.svg"
                  }
                  data-tip="Delete"
                  alt="Close"
                  onClick={() => this.deleteRecord(value)}
                />
              </>
            );
          },
        },
      },
    ];
    const options = {
      filterType: "checkbox",
      download: false,
      print: false,
      textLabels: {
        body: {
          noMatch: this.state.loading ? (
            "Sorry, there is no matching data to display"
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              style={{ margin: "auto" }}
            />
          ),
        },
      },
      onTableChange: (action, tableState) => {
        if (this.state.isdownloadExcelFirstLoadDone === 0) {
          if (action === "propsUpdate") {
            this.setState({
              downloadExcel: tableState.displayData,
              isdownloadExcelFirstLoadDone: 1,
            });
          }
        }
        if (action === "search" || action === "sort") {
          (async () => {
            await this.setState({ downloadExcel: [] });
          })();
          this.setState({ downloadExcel: tableState.displayData });
        }
      },
      customToolbar: () => {
        return (
          <>
            <button
              className="MuiButtonBase-root MuiIconButton-root MUIDataTableToolbar-icon-23"
              tabindex="0"
              type="button"
              data-testid="Download CSV-iconButton"
              aria-label="Download CSV"
              onClick={this.downloadExcelFile}
            >
              <span className="MuiIconButton-label">
                <svg
                  className="MuiSvgIcon-root"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"></path>
                </svg>
              </span>
              <span className="MuiTouchRipple-root"></span>
            </button>
          </>
        );
      },
    };

    return (
      <>
        <Modal show={this.state.deletePopup}>
          <Modal.Header>Delete Confirmation</Modal.Header>
          <Modal.Body>
            <div className="alert alert-danger" role="alert">
              Are you sure you want to delete?
            </div>
            <hr></hr>
            <div className="text-right">
              <Button className="btn btn-light" onClick={this.cancelDelete}>
                {" "}
                No{" "}
              </Button>
              <Button
                className="btn btn-primary-01 ml-3"
                onClick={this.confirmDelete}
              >
                {" "}
                Yes{" "}
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={this.state.delagationpopup} size="lg">
          <Modal.Header>Employee Look Up</Modal.Header>
          <Modal.Body>
            <section className="p-3">
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted"
                >
                  Employee Id
                </label>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="number"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationEmployeeId"
                      value={this.state.popupdelegationEmployeeId}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-name"
                  className="col-sm-3 col-form-label text-muted"
                >
                  Employee Name
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      Autocomplete="off"
                      className="form-control"
                      name="popupdelegationEmployeeName"
                      value={this.state.popupdelegationEmployeeName}
                      onChange={this.handlechange}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row mb-1">
                <label
                  for="auth-cat"
                  className="col-sm-3 col-form-label text-muted"
                >
                  Section
                </label>
                <div className="col-sm-6">
                  <div className="form-group">
                    <Select
                      options={sectionOptionList}
                      onChange={this.handledelegationSelectFormFields}
                      onKeyDown={this._handleKeyDown}
                    />
                  </div>
                </div>
              </div>
              <div className="text-right">
                <Button
                  className="btn btn-light"
                  onClick={() => this.searchdelegationEmployeeClear()}
                >
                  {" "}
                  Clear{" "}
                </Button>
                <Button
                  className="btn btn-primary-01 ml-3"
                  onClick={this.searchdelegationEmployee}
                >
                  {" "}
                  Search{" "}
                </Button>
              </div>
            </section>
            <hr></hr>
            <section>
              <h2 className="fs-title"> </h2>
              <div className="table-responsive max-height-280">
                <table className="table table-hover">
                  <thead className="thead-lightBlue">
                    <tr>
                      <th scope="col"> Action </th>
                      <th scope="col"> Employee No </th>
                      <th scope="col"> User Name </th>
                      <th scope="col"> Account </th>
                      <th scope="col"> Email </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Section Name </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.StaffDetailslistArray.map((staff, index) => (
                      <tr
                        onClick={() =>
                          this.getdelegationDetails(
                            staff.EmployeeId,
                            staff.Name
                          )
                        }
                        className="cursor-pointer"
                      >
                        <td>
                          {" "}
                          <p>
                            {" "}
                            <span className="material-icons-outlined select-employee-icon">
                              {" "}
                              how_to_reg{" "}
                            </span>{" "}
                          </p>{" "}
                        </td>
                        <td> {staff.EmployeeId} </td>
                        <td> {staff.Name} </td>
                        <td> ({staff.Account}) </td>
                        <td> {staff.Email} </td>
                        <td> {staff.Section} </td>
                        <td> {staff.SectionName} </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {(() => {
                  if (
                    this.state.StaffDetailslistArray.length <= 0 &&
                    this.state.stafflistArraySpin === "none"
                  ) {
                    return <p className="text-center">No record found.</p>;
                  }
                })()}
                <p className="text-center">
                  <Spinner
                    animation="border"
                    variant="primary"
                    style={{ display: this.state.stafflistArraySpin }}
                    className="text-center"
                  />
                </p>
              </div>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-light"
              onClick={() => this.getdelegationhide()}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Breadcrumb>
          <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
            Dashboard
          </Breadcrumb.Item>
          <Breadcrumb.Item active>Delegation</Breadcrumb.Item>
        </Breadcrumb>

        <div className="text-right mb-3">
          <Link to="/Delegation/create">
            <button type="button" className="btn btn-primary">
              {" "}
              Create
            </button>
          </Link>
        </div>
        <MUIDataTable
          title={""}
          data={dataArray}
          columns={columns}
          options={options}
        />
        <FloatingButton />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(delegationlist);
